import { setTheme } from './theme-loading';

setTheme();

import('./appBootstrap').then(({ appBootstrap }) => appBootstrap());
